import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import { getSection } from '../restapi/section';


// read the docId from url like /2021-05-12   (when empty use today)
export function useSectionId() {
	const {id} = useParams<{ id: string }>();
	return parseInt(id || '0');
}

export function useCurrentSec() {
	const secId = useSectionId();
	const secQuery = useQuery(['section', secId], () => getSection(secId));
	return secQuery.data;
}
